<footer class="footer">
    <div class="footer__terms">
        <ul>
            <li>
                <a [href]="footerLinks.termsOfUse" target="_blank" rel="noopener noreferrer">Terms of use</a>
            </li>
            <li>
                <a [href]="footerLinks.privacyCookies" target="_blank" rel="noopener noreferrer">Privacy & Cookies</a>
            </li>
            <li>
                <a [href]="footerLinks.helpCentre" target="_blank" rel="noopener noreferrer">Help Centre</a>
            </li>
        </ul>
    </div>
    <div class="footer__copyright">
        <p>© 2025 Deloitte Next Generation Deloitte Technology. All rights reserved.</p>
        <p>Deloitte Touche Tohmatsu India Private Limited (U74140MH199 5PTC093339) a private company limited by shares was converted into Deloitte Touche Tohmatsu India LLP, a limited liability partnership (LLP Identification No. AAE-8458) with effect from October 1, 2015. </p>
        <p>Deloitte refers to one or more of Deloitte Touche Tohmatsu Limited, a UK private company limited by guarantee (“DTTL”), its network of member firms, and their related entities. DTTL and each of its member firms are legally separate and independent entities. DTTL (also referred to as “Deloitte Global”) does not provide services to clients. Please see www.deloitte.com/about to learn more about our global network of member firms.</p>
    </div>
</footer>
